import React, { useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  const { t } = useI18n();
  useEffect(() => {
    document.title = `${t("pages.privacyTitle")} · ${t("brand.name")}`;
  }, [t]);

  const sections = [
    { title: null, text: t("privacy.intro") },
    ...Array.from({ length: 9 }, (_, i) => ({
      title: t(`privacy.s${i + 1}Title`),
      text: t(`privacy.s${i + 1}Text`),
    })),
  ];
  return <LegalLayout title={t("pages.privacyTitle")} updated={t("pages.privacyUpdated")} sections={sections} />;
}
